"use client";

import { Spinner } from "@/components/ui/spinner";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

interface CandidateRedirectClientProps {
  targetHref: string;
}

export default function CandidateRedirectClient({
  targetHref,
}: CandidateRedirectClientProps) {
  const router = useRouter();

  useEffect(() => {
    router.replace(targetHref);
  }, [router, targetHref]);

  return (
    <div className="flex justify-center items-center h-[calc(100dvh-370px)]">
      <Spinner size={32} />
    </div>
  );
}
